import React from 'react';
import PropTypes from 'prop-types';
import {
  FDLozenge,
  FDStack,
} from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('Pillars', (theme) => ({
  lozengeWrapper: {
    '& > *': {
      // Override FD's colors with the new lozenge colors that were made for this design
      backgroundColor: `${theme.palette.facet.stone500} !important`,
      color: `${theme.palette.facet.oceana800} !important`,
    },
  },
}));

export const Pillars = ({
  value,
}) => {
  const classes = useStyles();

  if (!value) {
    return null;
  }

  const names = (Array.isArray(value) ? value : [value])
    .filter(name => !!name); // Meta form has some smart defaults that must be overcome
  if (names.length === 0) {
    return null;
  }

  return (
    <FDStack direction="row" spacing={1} wrap alignItems="center">
      {names.map(name => (
        <div key={name} className={classes.lozengeWrapper}>
          <FDLozenge key={name} label={name} color="info" />
        </div>
      ))}
    </FDStack>
  );
};

Pillars.defaultProps = {
};

Pillars.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
};
